(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('EntiteParente', EntiteParente);

    EntiteParente.$inject = ['$resource'];

    function EntiteParente ($resource) {
        var resourceUrl =  'api/entite-parentes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
